module.exports = __webpack_public_path__ + "img/community-discuss-04.69721eca.svg";